module.exports = __webpack_public_path__ + "img/bg-3.691ebcc0.png";